interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

/**
 * Loading spinner component.
 */
export function Spinner({ size = 'md', className = '' }: SpinnerProps) {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-8 h-8 border-3',
    lg: 'w-12 h-12 border-4',
  };

  return (
    <div
      className={`
        ${sizeClasses[size]}
        border-primary-500 border-t-transparent
        rounded-full animate-spin
        ${className}
      `}
    />
  );
}

interface LoadingOverlayProps {
  message?: string;
}

/**
 * Full-screen loading overlay.
 */
export function LoadingOverlay({ message = 'Loading...' }: LoadingOverlayProps) {
  return (
    <div className="fixed inset-0 bg-dark-100/90 flex items-center justify-center z-50">
      <div className="text-center">
        <Spinner size="lg" className="mx-auto mb-4" />
        <p className="text-gray-400">{message}</p>
      </div>
    </div>
  );
}

interface SkeletonProps {
  className?: string;
}

/**
 * Skeleton loading placeholder.
 */
export function Skeleton({ className = '' }: SkeletonProps) {
  return (
    <div
      className={`
        bg-dark-300 rounded animate-pulse
        ${className}
      `}
    />
  );
}

/**
 * Card skeleton for loading states.
 */
export function CardSkeleton() {
  return (
    <div className="card space-y-4">
      <Skeleton className="h-6 w-1/3" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-2/3" />
      <Skeleton className="h-10 w-full" />
    </div>
  );
}
